module.exports = __webpack_public_path__ + "assets/src/style/img/here-and-now.png?4b8e3688392ff951443d1487ca95cec3";